var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('service-worker-notifications'),_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{attrs:{"id":"loading-overlay"}},[_c('HdLoadingSpinner')],1):_vm._e()]),_c('router-view'),_c('portal-target',{attrs:{"name":"root","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }